import "@/App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { Toaster } from "@/components/ui/sonner";
import { CartProvider } from "@/context/CartContext";
import { Header } from "@/components/Header";
import { Footer } from "@/components/Footer";
import { CartDrawer } from "@/components/CartDrawer";
import { SmoothScroll } from "@/components/SmoothScroll";
import Home from "@/pages/Home";
import Shop from "@/pages/Shop";
import Admin from "@/pages/Admin";
import { PaymentSuccess, PaymentCancel } from "@/pages/Payment";

function App() {
  return (
    <div className="App">
      <BrowserRouter>
        <CartProvider>
          <SmoothScroll />
          <Header />
          <Routes>
            <Route path="/" element={<Home />} />
            <Route path="/shop" element={<Shop />} />
            <Route path="/admin" element={<Admin />} />
            <Route path="/payment/success" element={<PaymentSuccess />} />
            <Route path="/payment/cancel" element={<PaymentCancel />} />
          </Routes>
          <Footer />
          <CartDrawer />
          <Toaster position="bottom-left" />
        </CartProvider>
      </BrowserRouter>
    </div>
  );
}

export default App;
